import React, { useState, useEffect, useContext } from 'react';
import { MessagePropertiesContext } from '../../../../contexts/messageProperties';
import { ListerContext } from '../../listerContext';
import AppliedFacets from './appliedFacets';
import { BreadcrumbData } from '../../../../types';
import useListerApi from '../../listerApiHooks';

function AppliedFacetsContainer(): React.ReactElement {
  const [isExpanded, setIsExpanded] = useState(false);
  const [appliedFacets, setAppliedFacets] = useState<BreadcrumbData[]>([]);
  const [formattedMessage] = useContext(MessagePropertiesContext);
  const [{ isListerDisabled, breadcrumbs }] = useContext(ListerContext);
  const { selectFacet } = useListerApi();

  useEffect(() => {
    setAppliedFacets(breadcrumbs);
  }, [breadcrumbs]);

  useEffect(() => {
    if (appliedFacets.length > 0 && !isExpanded) {
      setIsExpanded(true);
    }
    if (appliedFacets.length === 0 && isExpanded) {
      setIsExpanded(false);
    }
  }, [appliedFacets]);

  const clearHandler = (): void => {
    selectFacet().then(() => {
      setIsExpanded(false);
    });
  };

  const removeHandler = (location: string): void => {
    selectFacet(location).then((response) => {
      setAppliedFacets(response.breadcrumbs);
    });
  };

  return (
    <AppliedFacets
      appliedFacets={appliedFacets}
      isExpanded={isExpanded}
      isDisabled={isListerDisabled}
      clearHandler={clearHandler}
      removeHandler={removeHandler}
      messages={{
        title: formattedMessage({ id: 'search.nav.appliedFacets.title', fallback: 'Applied Filters' }),
        clearLabel: formattedMessage({ id: 'search.nav.appliedFacets.clear.label', fallback: 'Clear All' })
      }}
    />
  );
}

export default AppliedFacetsContainer;
